"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDefaultType = void 0;
var _issueTypes = require("../state/redux/ducks/issueTypes");
var _hooks = require("../state/redux/hooks");
var _useLocalStorage = require("../hooks/useLocalStorage");
const useDefaultType = () => {
  const [getLastSelectedTypeId] = (0, _useLocalStorage.useLocalStorage)(_useLocalStorage.LocalStorageKeys.LAST_SELECTED_TYPE_ID);
  const lastSelectedTypeId = getLastSelectedTypeId();
  const issueEntitiesMap = (0, _hooks.useSelector)(_issueTypes.getIssueTypeEntitiesMap);
  const fallbackDefaultType = (0, _hooks.useSelector)(_issueTypes.getFallbackDefaultType);
  const selectedType = lastSelectedTypeId && issueEntitiesMap[lastSelectedTypeId];
  const defaultType = selectedType && selectedType.isActive ? selectedType : fallbackDefaultType;
  return defaultType;
};
exports.useDefaultType = useDefaultType;
//# sourceMappingURL=useDefaultType.js.map